import usersService from "./users.service";
import {
  DeleteAccountDto,
  GetApiIntegrationDto,
  PublicUserDto,
  ResetPasswordDto,
  UpdateUserDto,
  UserDto,
} from "./users.types";
import { AvailableAPIProvidersType } from "../apiURLS";
import { createThunkWithError } from "../featureHelpers/errorParser";

// getMe
export const getMe = createThunkWithError<UserDto, void>("users/me", async () =>
  usersService.getMe(),
);

// get-public-user
export const getPublicUser = createThunkWithError<PublicUserDto, string>(
  "users/get-public-user",
  async (userName) => usersService.getPublicUser(userName),
);

// get API integrations
export const getAPIIntegrations = createThunkWithError<
  GetApiIntegrationDto[],
  void
>("users/get-api-integrations", async () => usersService.getAPIIntegrations());

// update user (custom reject type)
export const updateUser = createThunkWithError<UserDto, UpdateUserDto>(
  "users/update",
  async (updateUserData) => usersService.updateUserData(updateUserData),
);

// request verification token (void)
export const requestVerificationToken = createThunkWithError<void, void>(
  "users/request-verification-token",
  async () => {
    await usersService.requestVerificationToken();
  },
);

// verify account
export const verifyAccount = createThunkWithError<UserDto, string>(
  "users/verify",
  async (verifyToken) => {
    if (!verifyToken) throw new Error("No user token");
    return usersService.verifyAccount(verifyToken);
  },
);

// request password reset token
export const requestPasswordResetToken = createThunkWithError<void, string>(
  "users/requestPasswordResetToken",
  async (email) => {
    if (!email) throw new Error("Password reset request did not work");
    return usersService.requestPasswordResetToken(email);
  },
);

// request password reset token
export const requestAccountDeletion = createThunkWithError<void, string>(
  "users/requestAccountDeletion",
  async (email) => {
    if (!email) throw new Error("Password reset request did not work");
    return usersService.requestAccountDeletion(email);
  },
);

// request password reset token
export const deleteAccount = createThunkWithError<void, DeleteAccountDto>(
  "users/deleteAccount",
  async (data) => {
    if (!data.deleteToken || !data.email) throw new Error("No data provided");
    return usersService.deleteAccount({
      email: data.email,
      deleteToken: data.deleteToken,
    });
  },
);

// reset password
export const resetPassword = createThunkWithError<void, ResetPasswordDto>(
  "users/resetPassword",
  async (dto) => {
    if (!dto) throw new Error("Password reset request did not work");
    return usersService.resetPassword(dto);
  },
);

// remove API integration
export const removeAPIIntegration = createThunkWithError<string, string>(
  "users/removeAPIIntegration",
  async (id) => usersService.removeAPIIntegration(id),
);

// register API integration
export const registerAPIIntegration = createThunkWithError<
  GetApiIntegrationDto[],
  {
    provider: AvailableAPIProvidersType;
    providerToken: string;
    codeVerifier: string;
    redirectUri?: string;
  }
>(
  "users/registerAPIIntegration",
  async ({ provider, providerToken, codeVerifier, redirectUri }) => {
    const res = await usersService.registerAPIIntegration(
      providerToken,
      provider,
      codeVerifier,
      redirectUri,
    );
    return res;
  },
);
